import request from '@/utils/request'

export function fetchList(data) {
  return request({
    url: '/SysRole/List',
    method: 'post',
    data,
  })
}

export function fetchUserProfileList(data) {
  return request({
    url: '/SysRole/UserProfileList',
    method: 'post',
    data,
  })
}

export function fetchCoachList(data) {
  return request({
    url: '/SysRole/CoachList',
    method: 'post',
    data,
  })
}

export function getItem(id) {
  return request({
    url: '/SysRole/Get',
    method: 'post',
    data: { id },
  })
}

export function createItem(data) {
  console.log('createItem', data)

  return request({
    url: '/SysRole/Create',
    method: 'post',
    data,
  })
}

export function updateItem(data) {
  console.log('updateItem', data)

  return request({
    url: '/SysRole/Update',
    method: 'post',
    data,
  })
}

export function deleteItem(data) {
  return request({
    url: '/SysRole/Delete',
    method: 'delete',
    data,
  })
}

export function updateRoleMenu(data) {
  console.log('updateRoleMenu', data)

  return request({
    url: '/SysRole/UpdateRoleMenu',
    method: 'post',
    data,
  })
}

export function fetchListByEndpoint() {
  return request({
    url: '/SysRole/ListByEndpoint',
    method: 'post',
    data: {
      page: 0,
      limit: 0,
    },
  })
}

export function fetchOnlyCoachList(data) {
  return request({
    url: '/SysRole/fetchOnlyCoachList',
    method: 'post',
    data,
  })
}
